// extracted by mini-css-extract-plugin
export default {"wallet-alert__wrapper":"styles_wallet-alert__wrapper__-ISgs","walletAlertWrapper":"styles_wallet-alert__wrapper__-ISgs"};